<template>
  <vs-popup
    v-if="popupActive"
    fullscreen
    :title="popupActive ? popupCampaign.title : ''"
    :active.sync="popupActive"
  >
    <vs-row>
      <vs-col v-if="popupCampaign.hasEmail" :vs-w="popupCampaign.hasSms ? 8 : 12">
        <vs-row vs-justify="center" class="mb-2">
          <h4>Email "{{ popupCampaign.emailSubject }}"</h4>
        </vs-row>

        <div class="position-relative w-100" style="height: 800px">
          <iframe width="100%" height="100%" :srcdoc="emailPreviewHtml"></iframe>
        </div>
      </vs-col>
      <vs-col v-if="popupCampaign.hasSms" vs-w="4">
        <vs-row vs-justify="center" class="mb-2">
          <h4>Sms</h4>
        </vs-row>
        <div class="px-5">
          <vs-textarea
            class="smsContentContainer"
            :readonly="true"
            height="200px"
            v-model="smsPreviewContent"
          />
        </div>
      </vs-col>
    </vs-row>
    <div v-if="showActiveRejectButtons">
      <vs-row vs-justify="center" class="my-5">
        <vs-button class="mr-2 py-6" :color="popupAction == 0 ? 'green' : 'primary'" @click="popupAction = 0"
          >Approve</vs-button
        >
        <vs-button class="py-6" :color="popupAction == 1 ? 'danger' : 'primary'" @click="popupAction = 1"
          >Reject</vs-button
        >
      </vs-row>
      <vs-row vs-justify="center" v-if="popupAction == 1">
        <vs-col vs-w="4">
          <vs-textarea
            label="Reject reason"
            placeholder="Specity the reason for rejecting. This will make it easier to correct the issue."
            v-model="popupCampaign.rejectedComment"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center" class="my-5">
        <vs-button class="py-6" :disabled="popupAction == null" color="primary" @click="onPopupSubmit"
          >Submit</vs-button
        >
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      popupActive: false,
      popupCampaign: null,
      popupAction: null,
      masterCampaign: null,
    };
  },
  methods: {
    async show(campaign, masterCampaign) {
      this.popupCampaign = campaign;
      this.masterCampaign = masterCampaign;
      this.popupAction = null;
      this.popupActive = true;

      await this.$store.dispatch("venueCampaigns/getPreviewHtml", this.popupCampaign.id);
    },
    async onPopupSubmit() {
      let action = "";
      if (this.popupAction == 0) action = "approved";
      if (this.popupAction == 1) action = "rejected";
      try {
        if (this.popupAction == 0) {
          // Approve
          await this.$store.dispatch("venueCampaigns/approve", this.popupCampaign);
        } else if (this.popupAction == 1) {
          await this.$store.dispatch("venueCampaigns/reject", this.popupCampaign);
        }

        this.$vs.notify({
          color: "green",
          title: "Campaign " + action,
          text: "The campaign was successfully " + action,
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign could not be " + action,
          text: err,
        });
      } finally {
        this.$vs.loading.close();
        this.popupActive = false;
        this.popupAction = null;
        this.popupCampaign = null;
        this.masterCampaign = null;
        await this.$store.dispatch("venueCampaigns/getForMasterCampaign", this.masterCampaign.id);
      }
    },
  },
  computed: {
    ...mapGetters({
      emailPreviewHtml: "venueCampaigns/emailPreviewHtml",
      smsPreviewContent: "venueCampaigns/smsPreviewContent",
    }),
    showActiveRejectButtons() {
      return (
        this.masterCampaign.masterStatus == "Active" && this.popupCampaign.status == "SubmittedForApproval"
      );
    },
  },
};
</script>

<style lang="scss">
.smsContentContainer textarea {
  height: 100%;
}
</style>